import React from 'react';
import { User } from '../../app/consumer/header/user.transformer.types';
import { JsonObject } from '../../definitions/JsonObject';

interface MessagesPanelProps {
  messageCount: number;
  content: JsonObject;
  user: User;
}

export default function MessagesPanel({ content, messageCount, user }: MessagesPanelProps) {
  const showMessagesZeroState = messageCount === 0;
  return (
    <ul className="cw_panel_new cw_panel_messages" id="cw_panel-messages">
      {showMessagesZeroState ? (
        <ZeroStateMessage content={content} />
      ) : (
        <MessageTile messageCount={messageCount} content={content} />
      )}
      {user.isMobileIdUser && <MobileIdInbox content={content} />}
    </ul>
  );
}

/*
	renders secure message tile with message based on the count
*/
export function MessageTile({ messageCount, content }: { messageCount: number; content: JsonObject }) {
  const description =
    messageCount === 1 ? content.secureMessageDescriptionSingle || '' : content.secureMessageDescriptionPlural || '';

  return (
    <li id="secureMessage" className="cw_msg_new cw_message_tab">
      <div className="cw_notification-header">{content.secureMessagesHeader}</div>
      <div className="cw_notification-description">{description.replace('{count}', messageCount)}</div>
      <a href="/smc/async/" className="cw_notification-link">
        {content.secureMessageLink}
      </a>
    </li>
  );
}

/*
	renders mobile id inbox tile with message
*/
export function MobileIdInbox({ content }: { content: JsonObject }) {
  return (
    <li id="secureMessageTwo" className="cw_notification">
      <div className="cw_notification-header">{content.inboxMessagesHeader}</div>
      <div className="cw_notification-description">{content.inboxMessageDescription}</div>
      <a href="/messages/" className="cw_notification-link">
        {content.inboxMessageLink}
      </a>
    </li>
  );
}

/*
	renders the zero state tile that displays a message when no notification/message tiles are present
	isMessageTile flag set to true will render zerostate for messages, default is notifications
*/
export function ZeroStateMessage({ content }: { content: JsonObject }) {
  const message = content.zeroStateMessage;
  const subHeader = content.MessagesSubHeader;
  return (
    <li className="cw_notification cw_message_tab">
      <div className="cw_notification-subheader">{subHeader}</div>
      <div className="cw_notification-description">{message}</div>

      <a href="/smc/async/" className="cw_notification-link">
        {content.secureMessageLink}
      </a>
    </li>
  );
}
